import { Component, OnInit } from '@angular/core';
import { Chart } from 'node_modules/chart.js';
import { StoreService } from 'src/app/store.service';
import * as moment from 'moment';
import { Router } from '@angular/router';
import {
  ApexAnnotations,
  ApexAxisChartSeries,
  ApexChart,
  ApexDataLabels,
  ApexFill,
  ApexGrid,
  ApexLegend,
  ApexMarkers,
  ApexNonAxisChartSeries,
  ApexOptions,
  ApexPlotOptions,
  ApexResponsive,
  ApexStroke,
  ApexTheme,
  ApexTitleSubtitle,
  ApexXAxis,
  ApexYAxis,
} from 'ng-apexcharts';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { DashboardCreateStoreComponent } from '../create-store/create-store.component';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { DataService } from '../../data.service';
import { DEALER_STATUS } from '../../core/constants/data.constant';
import { StoreInfoService } from 'src/app/store-info.service';
import { environment } from 'src/environments/environment';
let primary = '#2152ff';

export type ChartOptions = {
  series?: ApexAxisChartSeries | ApexNonAxisChartSeries;
  chart?: ApexChart;
  xaxis?: ApexXAxis | ApexXAxis[];
  stroke?: ApexStroke;
  tooltip?: any;
  dataLabels?: ApexDataLabels;
  yaxis?: ApexYAxis | ApexYAxis[];
  legend?: ApexLegend;
  labels?: string[];
  plotOptions?: ApexPlotOptions;
  fill?: ApexFill;
  responsive?: ApexResponsive[];
  pieseries?: ApexNonAxisChartSeries;
  title?: ApexTitleSubtitle;
  theme?: ApexTheme;
  colors?: string[];
  markers?: ApexMarkers;
  annotations?: ApexAnnotations;
  grid?: ApexGrid;
  options?: ApexOptions;
  subtitle?: ApexTitleSubtitle;
};

@Component({
  selector: 'app-overview',
  templateUrl: './overview.component.html',
  styleUrls: ['./overview.component.scss'],
})
export class OverviewComponent implements OnInit {
  performingData: any = {
    daily: [],
    today: [],
    yesterday: [],
    curr_month: [],
    last_month: [],
    curr_year: [],
    last_year: [],
    chart: null,
  };
  performingOptions: any;

  salesType: any;
  salesOptions: any;

  customerType: any;
  customerData: any = {
    daily: [],
    today: [],
    yesterday: [],
    curr_month: [],
    last_month: [],
    curr_year: [],
    last_year: [],
    chart: null,
  };
  customerOptions: any;

  productType: any;
  productData: any;
  productOptions: any;

  date = new Date();

  bearer;
  storeList;
  store_id;
  storeName;
  storeDiscount;
  countryList;
  countryListWithData = [];
  countryName = 'Select Country';
  selectedCountryCode = '';
  countryFlag = '';
  currency = '';
  orderSummary = [];
  lastYearOrderSummary = [];
  getSaleChart;
  repeatCustomer;
  recentOrder;
  weekOrder = [];
  totalSale = 0;
  totalPv = 0;
  currMonthSummary = [];
  lastMonthSummary = [];
  featurePlan;
  dealerStatus: string;
  status: string;

  global_total_success;
  global_total_pending;
  global_total_cancel;

  DATE_FILTERS = [
    { display: 'Today', value: 'today', range: false },
    { display: 'Yesterday', value: 'yesterday', range: false },
    { display: 'Current Month', value: 'curr_month', range: false },
    { display: 'Last Month', value: 'last_month', range: false },
    { display: 'Current Year', value: 'curr_year', range: false },
    { display: 'Last Year', value: 'last_year', range: false },
  ];

  dateFilter = {
    type: null,
    yesterday: {
      sales: 0,
      totalOrders: 0,
    },
    today: {
      sales: 0,
      totalOrders: 0,
    },
    cm: {
      sales: 0,
      totalOrders: 0,
    },
    lm: {
      sales: 0,
      totalOrders: 0,
    },
    cy: {
      sales: 0,
      totalOrders: 0,
    },
    raw: [],
  };
  createStore = false;
  storeInfo$ = this.storeInfoService.getStoreInfos();
  isSvoStore: boolean = true;
  isGmStore: boolean = false;

  constructor(
    private svc: StoreService,
    private router: Router,
    public utils: UtilitiesService,
    private modalService: NgbModal,
    public dataService: DataService,
    private storeInfoService: StoreInfoService
  ) {
    this.dateFilter.type = this.DATE_FILTERS[2];
  }

  ngOnInit() {
    this.bearer = localStorage.getItem('bearer');
    this.store_id = localStorage.getItem('store_id');
    const info = JSON.parse(localStorage.getItem('5s-info'));
    this.status = info.status;
    this.dealerStatus = DEALER_STATUS[this.status].status;
    if (this.store_id === 'undefined' || this.store_id === null){
      this.utils.errorUnauthorized();
    }
    this.storeInfo$.subscribe((res) => {
      this.isSvoStore = res?.config?.is_svo_store;
      this.isGmStore = !!(this.isSvoStore || environment?.storeSubdomain?.includes('estoreglobe') || environment?.storeSubdomain?.includes('globemerce'));
      this.storeName = res.store_name;
      document.getElementById('store-name').innerHTML = this.storeName;
      localStorage.setItem('store_id', this.store_id);
      localStorage.setItem('store_url', res.store_url);
      this.getDealerPlan(this.bearer, info.d_id);

      this.svc
        .getLatestSummary(this.bearer, this.store_id)
        .subscribe((res2) => { });

      this.svc.getCountry(this.bearer).subscribe(
        (res) => {
          res['data'].forEach((item) => {
            item.country_name = item.country_name.split('-').pop().trim();
            if (item['country_flag'] === '') {
              let flag = item['country_code'].substr(-2).toLowerCase();
              item['country_flag'] =
                'https://cdn.estore5s.com/asset/flags/' + flag + '.png';
            } else {
              item['country_flag'] = item['country_flag'];
            }
          });
          this.countryList = res['data'];
          let defaultCountry = this.countryList.find((index) => {
            if (parseInt(index['default']) === 1) {
              return index;
            }
          });

          this.svc.getCountryWithOrder(this.bearer).subscribe((res) => {
            if (res?.status_code === 'OK') {
              const countryWithDataCodes = res.data?.map(
                (c) => c.country_code
              );
              this.countryListWithData = this.countryList.filter((c) => {
                return countryWithDataCodes.includes(c.country_code);
              });
            }
            if (this.countryListWithData.length === 0) {
              this.countryListWithData = [defaultCountry];
            }

            this.countryName =
              this.countryListWithData[0]['country_name'] ||
              this.countryList[0]['country_name'];
            this.countryFlag =
              this.countryListWithData[0]['country_flag'] ||
              this.countryList[0]['country_flag'];

            let country = this.countryList.find((index) => {
              return index.country_name === this.countryName;
            });

            this.getReport(country);
          });

        },
        (error) => {
          let errorMsg = error?.error?.error ?? 'Error';
        }
      );
    },
      (error) => {
        let errorMsg = error?.error?.error ?? 'Error';
        this.utils.errorUnauthorized();
      }
    );
  }

  getDealerPlan(token, dealerId) {
    this.svc.getDealerPlan(token, dealerId).subscribe((res) => {
      if (
        +res['data']['store_number'] > this.dataService.storeAmount &&
        res['data']['feature_list'].includes('multi-estore')
      ) {
        this.createStore = true;
      }
      this.dataService.updateDealerPlan(res['data']);
      this.dataService.updateDealerSubStatus(
        res['data']['dealer_subscription_status']
      );
    });
  }

  getReport(country) {
    this.date = new Date();
    this.performingData = {
      daily: [],
      today: [],
      yesterday: [],
      curr_month: [],
      last_month: [],
      curr_year: [],
      last_year: [],
      chart: null,
    };
    this.customerData = {
      daily: [],
      today: [],
      yesterday: [],
      curr_month: [],
      last_month: [],
      curr_year: [],
      last_year: [],
      chart: null,
    };
    this.orderSummary = [];
    this.lastYearOrderSummary = [];
    this.weekOrder = [];
    this.currMonthSummary = [];
    this.lastMonthSummary = [];
    this.dataMonth();
    this.months();

    this.currency = country['currency_symbol'];
    let currMonth = moment(this.date).format('YYYYMM');
    let lastMonth = moment(this.date.setMonth(this.date.getMonth() - 1)).format(
      'YYYYMM'
    );
    let currYear = moment(this.date).format('YYYY');
    let lastYear = (parseInt(moment(this.date).format('YYYY')) - 1).toString();
    this.weeklyOrder(this.store_id, country['country_code']);

    this.svc
      .getOrderSummary(this.store_id, country['country_code'], this.bearer)
      .subscribe((res) => {
        res['data'].sort((a, b) => {
          if (a.id > b.week_no) {
            return 1;
          } else if (a.week_no < b.week_no) {
            return -1;
          } else {
            return 0;
          }
        });

        res['data'].forEach((item) => {
          if (item['period'] == currMonth) {
            this.currMonthSummary.push(item);
          }
          if (item['period'] == lastMonth) {
            this.lastMonthSummary.push(item);
          }
          if (item['period'].toString().substr(0, 4) == currYear) {
            this.orderSummary.push(item);
          }
          if (item['period'].toString().substr(0, 4) == lastYear) {
            this.lastYearOrderSummary.push(item);
          }
        });
        this.prepareData();
        this.loadPerformingChart();
        // this.loadCustomerChart();
      });

    this.svc
      .getSaleChart(this.store_id, country['country_code'], this.bearer)
      .subscribe((res) => {
        this.getSaleChart = res['data'];
        const firstChart = res['data'][this.dateFilter.type.value];
        this.loadSalesChart(
          firstChart['success'],
          firstChart['pending'],
          firstChart['cancel']
        );
        const transformedData: { [key: string]: number } = {};
        Object.keys(res['data']).forEach((key) => {
          if (key !== 'all_time') {
            transformedData[key] = res['data'][key]['success'];
          }
        });

        this.repeatCustomer = res['data']['all_time']['repeat_customer'];
        this.totalSale = res['data']['all_time']['total_sales'];
        this.totalPv = res['data']['all_time']['total_profit'];

        this.global_total_success = firstChart['success'];
        this.global_total_pending = firstChart['pending'];
        this.global_total_cancel = firstChart['cancel'];
      });
  }

  changeCountry(countryCode) {
    let country = this.countryList.find((index) => {
      return index.country_code == countryCode;
    });
    this.selectedCountryCode = country.country_code;
    this.countryFlag = country.country_flag;
    this.countryName = country.country_name;
    this.getReport(country);
  }

  overviewData() {
    // const chart = this.performingData.chart;
    const apxchart = this.performingData.chart;
    var getData = this.getData(this.performingData, this.dateFilter.type.value);
    apxchart.labels = this.getLabels(
      this.performingData,
      this.dateFilter.type.value
    );
    apxchart.series = [{ name: this.currency, data: getData }];
    // apxchart.update();

    let sale_chart = this.getSaleChart[this.dateFilter.type.value];
    let total_success = sale_chart['success'];
    let total_pending = sale_chart['pending'];
    let total_cancel = sale_chart['cancel'];
    this.loadSalesChart(total_success, total_pending, total_cancel);
    this.global_total_success = total_success;
    this.global_total_pending = total_pending;
    this.global_total_cancel = total_cancel;
  }

  dataMonth() {
    let month = this.date.getMonth();
    let year = this.date.getFullYear();
    var first, last, start, end;

    // current month
    first = moment().month(month).year(year).startOf('month').isoWeek();
    last = moment().month(month).year(year).endOf('month').isoWeek();
    for (var i = first; i <= last; i++) {
      this.performingData['curr_month'].push({
        label: this.utils.translate('Week {0}', [i]),
        value: 0,
      });
      this.customerData['curr_month'].push({
        label: this.utils.translate('Week {0}', [i]),
        value: 0,
      });
    }

    // last month
    start = moment()
      .month(month - 1)
      .year(year)
      .startOf('month')
      .isoWeek();
    end = moment()
      .month(month - 1)
      .year(year)
      .endOf('month')
      .isoWeek();
    for (var i = start; i <= end; i++) {
      this.performingData['last_month'].push({
        label: this.utils.translate('Week {0}', [i]),
        value: 0,
      });
      this.customerData['last_month'].push({
        label: this.utils.translate('Week {0}', [i]),
        value: 0,
      });
    }
  }

  weeklyOrder(store_id, country_code) {
    let today = moment().format('YYYY-MM-DD');
    let yesterday = moment().subtract(1, 'day').format('YYYY-MM-DD');

    this.svc
      .getWeekOrders(store_id, country_code, this.bearer)
      .subscribe((resp) => {
        resp['data'].forEach((item) => {
          this.performingData['daily'].push({
            label: item['date'],
            value: item['success_price'],
          });
          this.customerData['daily'].push({
            label: item['date'],
            value: item['success_qty'],
          });

          // today and yesterday order only
          if (item['date'] === today) {
            this.performingData['today'].push({
              label: item['date'],
              value: item['success_price'],
            });
            this.customerData['today'].push({
              label: item['date'],
              value: item['success_qty'],
            });
          }
          if (item['date'] === yesterday) {
            this.performingData['yesterday'].push({
              label: item['date'],
              value: item['success_price'],
            });
            this.customerData['yesterday'].push({
              label: item['date'],
              value: item['success_qty'],
            });
          }
        });
      });
  }

  months() {
    let m = moment.monthsShort();
    let month = moment.monthsShort(this.date.getMonth());
    m.every((item) => {
      this.performingData['curr_year'].push({ label: item, value: 0 });
      this.customerData['curr_year'].push({ label: item, value: 0 });
      this.performingData['last_year'].push({ label: item, value: 0 });
      this.customerData['last_year'].push({ label: item, value: 0 });
      return item != month;
    });
  }

  public apxchart: ChartOptions = {
    chart: {
      height: 370,
      type: 'area',
      fontFamily: 'inherit',
      zoom: { enabled: false },
      toolbar: { show: false },
    },
    dataLabels: { enabled: false },
    stroke: {
      curve: 'smooth',
      width: 2,
    },
    fill: {
      colors: [primary],
      type: 'gradient',
      gradient: {
        shade: 'light',
        type: 'vertical',
        shadeIntensity: 0.3,
        inverseColors: false,
        opacityFrom: 0.55,
        opacityTo: 0.03,
        stops: [0, 100],
      },
    },
    series: [{ name: this.currency, data: [] }],
    title: {
      text: this.utils.translate('Store Performance'),
      align: 'left',
      style: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#3E425B',
      },
    },
    colors: [primary],
    labels: [],
    xaxis: {
      type: 'category',
      labels: {
        style: { colors: '#747E8B', fontSize: '11px' },
        rotate: -30,
        rotateAlways: false,
      },
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      opposite: false,
      labels: {
        style: { colors: '#747E8B', fontSize: '11px' },
        formatter: (val: number) => {
          if (val >= 1000) return (val / 1000).toFixed(0) + 'k';
          return val.toFixed(0);
        },
      },
    },
    grid: {
      borderColor: 'rgba(62, 66, 91, 0.08)',
      strokeDashArray: 4,
      padding: { left: 0, right: 8, top: -10, bottom: 0 },
    },
    legend: { horizontalAlign: 'left' },
    responsive: [
      {
        breakpoint: 576,
        options: {
          chart: { height: 260 },
          xaxis: { labels: { style: { fontSize: '9px' } } },
        },
      },
    ],
  };

  loadPerformingChart() {
    let value = this.getData(this.performingData, this.dateFilter.type.value);
    let label = this.getLabels(this.performingData, this.dateFilter.type.value);

    var performanceChartData = this.apxchart;

    this.performingData.chart = performanceChartData;
    performanceChartData.series = [
      {
        name: this.currency,
        data: value,
      },
    ];

    performanceChartData.labels = label;
  }

  numFormat = {
    y: {
      formatter: function (value) {
        let num = value.toFixed(2);
        return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      },
    },
  };

  public sales: ChartOptions = {
    chart: {
      type: 'donut',
      height: 220,
      fontFamily: 'inherit',
    },
    plotOptions: {
      pie: {
        donut: { size: '70%' },
        expandOnClick: false,
      },
    },
    series: [],
    dataLabels: { enabled: false },
    stroke: { width: 0 },
    legend: { show: false },
    colors: ['#27AE60', '#FFB319', '#FF5733'],
    responsive: [
      {
        breakpoint: 576,
        options: { chart: { height: 180 } },
      },
    ],
  };

  loadSalesChart(data1: any, data2: any, data3: any) {
    var salesDonutChart = this.sales;
    salesDonutChart.labels = [
      `Success (${this.currency})`,
      `Pending (${this.currency})`,
      `Cancel (${this.currency})`,
    ];
    salesDonutChart.series = [data1, data2, data3];
  }

  loadCustomerChart() {
    let ctx = <HTMLCanvasElement>document.getElementById('customerChart');
    ctx.remove();
    ctx = document.createElement('canvas');
    ctx.setAttribute('id', 'customerChart');
    document.getElementById('customerChartDiv').appendChild(ctx);

    var canvas = <HTMLCanvasElement>document.getElementById('customerChart');
    var customerChart = canvas.getContext('2d');

    let getData = this.getData(this.customerData, this.dateFilter.type.value);
    var customerChartData = {
      labels: this.getLabels(this.customerData, this.dateFilter.type.value),

      datasets: [
        {
          // label: 'Count',
          backgroundColor: '#2152ff',
          borderWidth: 4,
          data: getData,
        },
        {
          label: 'Yesterday',
          backgroundColor: '#ffb31a',
          borderWidth: 4,
          data: [],
        },
      ],
    };

    var customerChartOptions = {
      responsive: true,
      maintainAspectRatio: false,
      animation: {
        easing: 'easeInOutQuad',
        duration: 520,
      },
      scales: {
        xAxes: [
          {
            gridLines: {
              color: 'rgba(62, 66, 91, 0.06)',
              lineWidth: 1,
              tickMarkLength: 1,
              zeroLineWidth: 0,
            },
            ticks: {
              padding: 10,
              fontColor: '#000',
            },
            categoryPercentage: 0.5,
            barPercentage: 1.25,
          },
        ],
        yAxes: [
          {
            gridLines: {
              color: 'rgba(62, 66, 91, 0.06)',
              lineWidth: 0,
              drawBorder: false,
              zeroLineWidth: 0,
              zeroLineColor: 'rgba(62, 66, 91, 0.06)',
            },
            ticks: {
              padding: 15,
              fontColor: '#000',
            },
          },
        ],
      },
      legend: {
        display: false,
      },
      tooltips: {
        intersect: false,
        titleFontFamily: 'Open Sans',
        backgroundColor: 'rgba(255,255,255,1)',
        titleFontColor: '#8F8F8F',
        titleFontStyle: 'normal',
        titleAlign: 'center',
        bodyFontColor: '#000',
        bodyAlign: 'center',
        bodyFontSize: 14,
        bodyFontStyle: 'bold',
        caretSize: 10,
        cornerRadius: 2,
        xPadding: 10,
        yPadding: 10,
        borderColor: '#ebebeb',
        borderWidth: 2,
        displayColors: false,
      },
    };

    this.customerData.chart = new Chart(customerChart, {
      type: 'bar',
      data: customerChartData,
      options: customerChartOptions,
    });
  }

  private getLabels(list, type) {
    const mapper = {
      daily: () => {
        return list['daily'].map((item) => item.label);
      },
      today: () => {
        return list['today'].map((item) => item.label);
      },
      yesterday: () => {
        return list['yesterday'].map((item) => item.label);
      },
      curr_month: () => {
        return list['curr_month'].map((item) => item.label);
      },
      last_month: () => {
        return list['last_month'].map((item) => item.label);
      },
      curr_year: () => {
        return list['curr_year'].map((item) => item.label);
      },
      last_year: () => {
        return list['last_year'].map((item) => item.label);
      },
    };

    const labels = mapper[type]();
    return labels;
  }

  private getData(list, type) {
    const mapper = {
      daily: () => {
        return list['daily'].map((item) => item.value);
      },
      today: () => {
        return list['today'].map((item) => item.value);
      },
      yesterday: () => {
        return list['yesterday'].map((item) => item.value);
      },
      curr_month: () => {
        return list['curr_month'].map((item) => item.value);
      },
      last_month: () => {
        return list['last_month'].map((item) => item.value);
      },
      curr_year: () => {
        return list['curr_year'].map((item) => item.value);
      },
      last_year: () => {
        return list['last_year'].map((item) => item.value);
      },
    };

    const data = mapper[type]();
    return data;
  }

  private prepareData() {
    this.remapList(
      this.performingData,
      this.currMonthSummary,
      'week_no',
      'success_price',
      'curr_month'
    );
    this.remapList(
      this.performingData,
      this.lastMonthSummary,
      'week_no',
      'success_price',
      'last_month'
    );
    this.remapList(
      this.performingData,
      this.orderSummary,
      'period',
      'success_price',
      'curr_year'
    );
    this.remapList(
      this.performingData,
      this.lastYearOrderSummary,
      'period',
      'success_price',
      'last_year'
    );

    this.remapList(
      this.customerData,
      this.currMonthSummary,
      'week_no',
      'success_qty',
      'curr_month'
    );
    this.remapList(
      this.customerData,
      this.lastMonthSummary,
      'week_no',
      'success_qty',
      'last_month'
    );
    this.remapList(
      this.customerData,
      this.orderSummary,
      'period',
      'success_qty',
      'curr_year'
    );
    this.remapList(
      this.customerData,
      this.lastYearOrderSummary,
      'period',
      'success_qty',
      'last_year'
    );
  }

  private remapList(
    which,
    list: any[],
    dateField,
    valueField,
    type = 'curr_month'
  ) {
    const mapper = {
      daily: (item) => {
        return item.format('YYYY-MM-DD');
      },
      today: (item) => {
        return item.format('YYYY-MM-DD');
      },
      yesterday: (item) => {
        return item.format('YYYY-MM-DD');
      },
      curr_month: (item) => {
        return item;
      },
      last_month: (item) => {
        return item;
      },
      curr_year: (item) => {
        return item;
      },
      last_year: (item) => {
        return item;
      },
    };

    list.map((item) => {
      const tempMonth = moment(item[dateField], 'YYYYMM').format('MMM');
      const Monthlabel = mapper[type](tempMonth);

      const tempDate = this.utils.translate('Week ') + item[dateField];
      const label = mapper[type](tempDate);

      const val = (valueField && item[valueField]) || 1;

      const index = which[type].findIndex((item) => item.label == label);
      const index2 = which[type].findIndex((item) => item.label == Monthlabel);

      if (type == 'curr_month' || type == 'last_month' || type == 'yearly') {
        if (index === -1) {
          which[type].push({
            label: label,
            value: (which[type][label] || 0) + val,
          });
        } else {
          which[type][index]['value'] = Number(val);
        }
      } else if (type == 'curr_year' || type == 'last_year') {
        if (index2 === -1) {
          which[type].push({
            label: Monthlabel,
            value: (which[type][Monthlabel] || 0) + Number(val),
          });
        } else {
          which[type][index2]['value'] =
            which[type][index2]['value'] +
            (which[type][Monthlabel] || 0) +
            Number(val);
        }
      }
    });
  }

  // "Run ads on Nexus": log the dealer into nexus via SSO and land on
  // /app/ads/create-ads?type=smart. The link is fetched on click (an SSO link
  // is a login credential, so it is not prefetched and kept on the page).
  nexusAdsLoading = false;

  openNexusAds() {
    if (this.nexusAdsLoading) {
      return;
    }

    // Open the tab now, while we are still inside the click: browsers block
    // window.open() once we are in the async callback.
    const tab = window.open('', '_blank');
    if (tab) {
      tab.opener = null;
    }

    const fail = () => {
      this.nexusAdsLoading = false;
      tab?.close();
      this.utils.notify.showError(
        this.utils.translate('Unable to open Nexus. Please try again.')
      );
    };

    this.nexusAdsLoading = true;
    this.svc
      .getNexusSsoLink({ store_id: this.store_id, destination: 'smart_ads' }, this.bearer)
      .subscribe(
        (res) => {
          const link = res?.['data']?.sso_link;
          if (!link) {
            return fail();
          }
          this.nexusAdsLoading = false;
          if (tab) {
            tab.location.href = link;
          } else {
            window.open(link, '_blank', 'noopener');
          }
        },
        () => fail()
      );
  }

  showCreateStore() {
    if (!this.createStore) {
      this.utils.notify.showError(
        this.utils.translate(
          'Unable to create store. You have reached maximum store limit'
        )
      );
      return false;
    } else {
      this.modalService.open(DashboardCreateStoreComponent, {
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        backdrop: 'static',
        size: 'lg',
      });
    }
  }

  get dealerWhitelistStatus() {
    let feature = localStorage.getItem('feature');
    if (
      feature !== undefined &&
      feature !== null &&
      feature !== '[]' &&
      feature !== ''
    ) {
      let features = feature.split(',');
      let check = features.find((t) => t === 'create-multi-estore');
      return check !== undefined && check !== null;
    } else {
      return false;
    }
  }

  get allowCreateStore() {
    return this.createStore === true;
  }

  get isConvertedSuspended(): boolean {
    return this.isConverted || this.isSuspended;
  }

  get isConverted(): boolean {
    return this.dealerStatus === 'Converted';
  }

  get isSuspended(): boolean {
    return this.dealerStatus === 'Suspended';
  }

  get canCreateStore(): boolean {
    return this.allowCreateStore && !this.isConvertedSuspended;
  }
}
